import { queryOptions, skipToken, useQuery } from '@tanstack/react-query';
import { type RespondedWith, responseScheme } from '@/models/response';
import { type UserInfoByCode, userInfoByCodeScheme } from '@/models/user/other-user-info';
import { fetcher } from '@/utils/fetcher';

export const generateUserInfoByCodeQueryOptions = (code: Nullable<string>) =>
  queryOptions({
    queryKey: ['/GetUserInfoByQRCode', code],
    queryFn: code
      ? ({ signal }) =>
          fetcher<RespondedWith<UserInfoByCode>>(
            '/GetUserInfoByQRCode',
            { QRCode: code },
            { signal, schema: responseScheme.extend({ Data: userInfoByCodeScheme }), validResponseCodes: [0] },
          )
      : skipToken,
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: false,
  });

export default function useUserInfoByCode(code: string | null | undefined) {
  return useQuery(generateUserInfoByCodeQueryOptions(code));
}
